import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPreReleaseClientsGet = {
    path: "/pre-release-clients",
    method: ERouteHttpVerb.GET
};
export { routeLocationPreReleaseClientsGet };
